module.exports = __webpack_public_path__ + "img/bigwavebottom.5fbb639c.png";